import { render, staticRenderFns } from "./CircleXIcon.vue?vue&type=template&id=67d05d4e&scoped=true"
import script from "./CircleXIcon.vue?vue&type=script&lang=js"
export * from "./CircleXIcon.vue?vue&type=script&lang=js"
import style0 from "./CircleXIcon.vue?vue&type=style&index=0&id=67d05d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d05d4e",
  null
  
)

export default component.exports